<template>
   <div>
    <el-table @cell-mouse-enter="rowHover" @cell-mouse-leave="rowHoverLeave"
              @row-click="rowClick"
              id="leadsTable" class="table-striped" 
              :data="paymentCardLogs" :row-class-name="noRowClick?'':'clickableRow'">

      <el-table-column label="Date" width="120">
        <template slot-scope="{row}">
          {{ displayDate(row.dateTransaction) }}
        </template>
      </el-table-column>

      <el-table-column label="Amount" width="80"> 
        <template slot-scope="{row}">
          {{ `${$store.getters.currency}${row.amount}` }}
        </template>
      </el-table-column>

      <el-table-column prop="merchantName" label="Merchant"/>

      <el-table-column prop="details" label="Details"/>

      <el-table-column prop="status" label="Status" width="140"/> 
      
    </el-table>
  </div>
</template>

<script>
import {Lead} from 'src/classes/datamodel.js'
import utils from '../../utils'
export default {
  name: 'Transactions-Table',
  props: {
    filter:          {type: Object, default: null},
    modal:           {type: Boolean, default: false},
    hideStatus:      {type: Boolean, default: false},
    noRowClick:      {type: Boolean, default: true}
  },
  data () {
    return {
      dialogModeAffiliate: '',
      dialogVisibleAffiliate: false,
      dialogModeCompany: '',
      dialogVisibleCompany: false
    }
  },
  computed: { 
    paymentCardLogs () {
      return this.$store.getters.paymentCardLogs
    }
  },
  methods: {
    displayDate (date) {
      return utils.dateToString(date)
    },
    addLead () {
      this.$store.dispatch('openModal', { name: 'Lead', mode: 'Create', object: new Lead({status: Lead._status.RECEIVED.value}) })
    },
    rowHover(row, column, cell, event) {
      // We show all buttons of class .showOnHover
      var rows = $('#leadsTable > div > table > tbody > tr')
      for (var i = 0; i < rows.length; i++) {
        var foundRow = JSON.stringify($(rows[i]).html().indexOf('leadid="'+row.id+'"')) > -1
        if (foundRow) {
          //$(rows[i]).css({'background-color': 'red'})
          //$(rows[i]).css({'border-style': 'solid'})
          var icons = $(rows[i]).find('.showOnHover')
          for (var j = 0; j < icons.length; j++) {
            if (!($(icons[j]).hasClass('hideIfLeadClose') && (row.status == 'closed' || row.status == 'lost'))) {
              $(icons[j]).removeClass('d-none')
            }
          }
          break
        }
      }
    },
    rowHoverLeave (row, column, cell, event) {
      // We hide all buttons of class .showOnHover
      var rows = $('#leadsTable > div > table > tbody > tr')
      for (var i = 0; i < rows.length; i++) {
        var index = JSON.stringify($(rows[i]).html().indexOf('leadid="'+row.id+'"'))
        if (index > -1) {
          //$(rows[i]).css({'border-style': 'hidden'})
          //$(rows[i]).css({'background-color': 'grey'})
          var icons = $(rows[i]).find('.showOnHover')
          for (var j = 0; j < icons.length; j++) {
            $(icons[j]).addClass('d-none')
          }
          break
        }
      }
    },
    rowClick (row, column, event) {
      // if rows are clickable
      if (!this.noRowClick) {
        // We only process the row click if the click didn't happen on a button
        // var match = JSON.stringify(event.toElement.classList.value).match(/fa[rsdl]{0,1}\sfa-|form-check-sign|form-check-input/i)
        var path = event.path || event.composedPath() // 2nd one if for Firefox
        var match = JSON.stringify(path[0].className).match(/fa[rsdl]{0,1}\sfa-|form-check-sign|form-check-input/i)
        //console.log('rowClick():', event.toElement.classList.value)
        if (match && match.index > -1) {
          //console.log('row click ignored')
        } else {
          //console.log('row click!')
          this.editLead(row)
        }
      }
    },
    async editLead (row) {
      if (this.modal) {
        this.$store.dispatch('closeModal')
      }
      this.$store.dispatch('openModal', {name: 'Lead', mode: 'Edit', object: new Lead(row)})
    },
    async changeLeadStatus(row, statusStr) {
      var newLead = new Lead(row)
      //newLead.contacts = new Array(newLead.contacts) // This is because the row (=lead) has weird objects instad of arrays
      var status = null
      switch (statusStr) {
        case 'received':
          status = Lead._status.RECEIVED.value
          break;
        case 'closed':
          status = Lead._status.CLOSED.value
          break;
        case 'lost':
          status = Lead._status.LOST.value
          break;
        default:
          console.log('!!!!! WARNING !!!!! LeadsTable.vue:(changeLeadStatus(), wrong status: ', statusStr)
          break;
      }
      newLead.status = status
      const res = await this.$store.dispatch('updateRestObject', newLead)
      if (res.errors) {
        if (!res.errors[0].toLowerCase().includes('session')) { // we don't show the error because the API service is rerouting to login page
          this.$notify({ errorMessage: res.errors[0] })
        }
      }
      else { this.$notify({ successMessage: 'Saved!'})
      }
    },
    async deleteLead (row) {
      const res = await this.$store.dispatch('deleteRestObject', new Lead(row))
      if (res.errors) {
        if (!res.errors[0].toLowerCase().includes('session')) { // we don't show the error because the API service is rerouting to login page
          this.$notify({ errorMessage: res.errors[0] })
        }
      }
      else { this.$notify({ successMessage: 'Deleted!'})
      }
    },
    async toggleHot (row) {
      let lead = new Lead(row)
      let res = null
      switch (row.hot) {
        case true:
          lead.hot = false
          res = await this.$store.dispatch('updateRestObject', lead)
          break
        case false:
          lead.hot = true
          res = await this.$store.dispatch('updateRestObject', lead)
          break
        default:
          res = {errors: ['Error while trying to toggle the hot status.']}
          console.log('error in LeadsTable.vue:toggleHot(), trying to change hot status of row: ', row)
          break
      }
      if (res.errors) {
        if (!res.errors[0].toLowerCase().includes('session')) { // we don't show the error because the API service is rerouting to login page
          this.$notify({ errorMessage: res.errors[0] })
        }
      }
      else { this.$notify({ successMessage: 'Saved!'})
      }
    },
      // This method is called when clicking a checkbox to select a row
      // It's going to update the ObjectsWithId in the state (selectedObjects.objectsJson)
      selectRow (row) {
        this.$store.commit('SELECT_OBJECT', row)
      },
      rowSelectable(row) {
        if (this.$store.getters.selectedObjectsJson) { // if selection mode is active
          let filter = this.$store.getters.selectedObjectsFilter
          let filterKeys = filter ? Object.keys(filter) : []
          let match = true
          filterKeys.forEach(key => {
            if (row[key] != filter[key]) {
              match = false
            }
          });
          return match
        }
        return false
      }
  },
  mounted () { // tentative to implement a better onHover for the table rows.. doesn't work
      $('.el-table__body').css({'border-collapse': 'collapse'})
      $('.el-table__body .el-table__row').css({'border-width': 'thin'})
      $('.el-table__body .el-table__row').css({'border-color': 'black'})
      $('.el-table__body .el-table__row').css({'border-style': 'hidden'})
  }
}
</script>

<style>

</style>